(function(){
    'use strict'

    angular.module('app.permisos')
    .factory('PermisosService', PermisosService);

    PermisosService.$inject = ['$http', '$q', 'apiSettings'];

    function PermisosService($http, $q, apiSettings) {

        var api = {
            getAll: getAll,
            getAllCompanias: getAllCompanias,
            getAllTiposPlanilla: getAllTiposPlanilla,
            save: save,
            saveCompanias: saveCompanias,
            saveTiposPlanilla: saveTiposPlanilla
        };

        return api;

        function getAll(grupoId){

            var url = apiSettings.apiBaseUrl + 'api/permisos/' + grupoId;
            
            return $http.get(url)
            .then(getAllSuccess, getAllError);

            function getAllSuccess(response){
                return response.data;
            };

            function getAllError(error) {
                return $q.reject(error);
            }
        };

        function getAllCompanias(grupoId){

            var url = apiSettings.apiBaseUrl + 'api/permisos-compania/' + grupoId;
            
            return $http.get(url)
            .then(getAllSuccess, getAllError);

            function getAllSuccess(response){
                return response.data;
            };

            function getAllError(error) {
                return $q.reject(error);
            }
        };

        function getAllTiposPlanilla(grupoId){

            var url = apiSettings.apiBaseUrl + 'api/permisos-tipo-planilla/' + grupoId;
            
            return $http.get(url)
            .then(getAllSuccess, getAllError);

            function getAllSuccess(response){
                return response.data;
            };

            function getAllError(error) {
                return $q.reject(error);
            }
        };

        function save(grupoId, permisos){
            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/permisos/' + grupoId,  
                method: 'POST',  
                data: permisos
            });  
            return response;
        };

        function saveCompanias(permisos){
            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/permisos-compania/',  
                method: 'POST',  
                data: permisos
            });  
            return response;
        };

        function saveTiposPlanilla(permisos){
            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/permisos-tipo-planilla/',  
                method: 'POST',  
                data: permisos
            });  
            return response;
        };
        
    };

})();